
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/tv",
      function () {
        return require("private-next-pages/m/tv/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/tv"])
      });
    }
  